<template>
  <div class="modal fade" tabindex="-1" ref="modalRef">
    <div class="modal-dialog  modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Скачать бланк</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="mb-3">
              <label for="fullName">ФИО</label>
              <div style="display: flex; align-items: center;">
              <input type="text" class="form-control" style="flex-grow: 1; margin-right: 10px;" id="fullName" v-model="fullName" />
              <button @click="addNewField" class="btn-labhub" type="button">+</button>
            </div>
            </div>
            <div v-for="(field, index) in additionalFields" :key="index" class="mb-2">
              <input type="text" class="form-control" v-model="field.name" />
            </div>
            <div>

              <h5 class="mb-2 mt-4">Заключение:</h5>
              <div style="overflow: auto; max-height: 300px; padding: 10px; border: 1px solid #e5f0ff; background: #fafcff;">
              <div v-for="(item, index) in documentFooter" :key="index">
                <label class="mb-2 mt-2">{{ item.name }}</label>
                <select
                  :key="index"
                  class="form-control"
                  v-model="footerData[item.name]"
                >
                  <option
                    v-for="(choice, choiceIndex) in item.choices"
                    :key="choiceIndex"
                    :value="choice"
                  >
                    {{ choice }}
                  </option>
                </select>
              </div>
            </div>

            </div>
            <div style="display: flex; align-items: center;">
            <button type="submit" class="btn-labhub mt-4 me-4">Скачать PDF</button>
            <button @click="downloadWord"  type="button" class="btn-labhub mt-4">Скачать Word</button>
          </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http';
import { Modal } from "bootstrap";

export default {
  props: ["documentId", "tableData"],
  data() {
    return {
      fullName: "",
      document: null,
      selectedOptions: {},
      headerData: {}, // Объект для хранения выбранных элементов в шапке
      footerData: {}, // Объект для хранения выбранных элементов в подвале
      additionalFields: [],
    };
  },
  computed: {
    documentHeader() {
      if (this.document) {
        return [...this.document.header];
      }
      return [];
    },
    documentFooter() {
      if (this.document) {
        return [...this.document.footer];
      }
      return [];
    },
  },
  async mounted() {
    this.modal = new Modal(this.$refs.modalRef);
    try {
      const response = await http.get(
        `documents/${this.documentId}`
      );
      this.document = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    show() {
      this.modal.show();
    },
    addNewField() {
      this.additionalFields.push({ name: '' });
    },
    async downloadWord() {
      event.stopPropagation(); // Останавливаем всплытие события
    try {
      // Создаем объект с данными для отправки на сервер
      const requestData = {
        documentName: this.document.name, // Название документа
        fullName: this.fullName, // ФИО
        headerData: this.headerData, // Выбранные элементы в шапке
        additionalFields: this.additionalFields,
        tableData: this.tableData, // Данные таблицы
        footerData: this.footerData, // Выбранные элементы в подвале
      };

      // Отправляем POST-запрос на сервер
      const response = await http.post(
        "word/generate",
        requestData,
        { responseType: "blob" } // Указываем, что ожидаем blob в ответе
      );

      // Проверяем код ответа
      if (response.status === 200) {
        // Создаем URL для скачивания файла
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
        const url = window.URL.createObjectURL(blob);

        // Создаем ссылку для скачивания
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "document.docx");

        // Эмулируем клик по ссылке для скачивания
        link.click();

        // Освобождаем ресурсы
        window.URL.revokeObjectURL(url);
      } else {
        // Обработка других кодов ответа
        // ...
      }

      // Закрываем модальное окно
      // this.modal.hide();
    } catch (error) {
      console.error(error);
    }
  },
    async handleSubmit() {
      try {
        // Создаем объект с данными для отправки на сервер
        const requestData = {
          documentName: this.document.name, // Название документа
          fullName: this.fullName, // ФИО
          headerData: this.headerData, // Выбранные элементы в шапке
          tableData: this.tableData, // Данные таблицы
          footerData: this.footerData, // Выбранные элементы в подвале
          additionalFields: this.additionalFields,
        };

             // Отправляем POST-запрос на сервер
      const response = await http.post(
        "pdf/generate",
        requestData,
        { responseType: "blob" } // Указываем, что ожидаем blob в ответе
      );

      // Проверяем код ответа
      if (response.status === 200) {
        // Создаем URL для скачивания файла
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        // Создаем ссылку для скачивания
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "document.pdf");

        // Эмулируем клик по ссылке для скачивания
        link.click();

        // Освобождаем ресурсы
        window.URL.revokeObjectURL(url);
      } else {
        // Обработка других кодов ответа
        // ...
      }

        // Закрываем модальное окно
        // this.modal.hide();
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
.input-blanc {
  width: 100%;
  height: 47px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #e5f0ff;
  background: #fff;
}
</style>
